module.exports = __webpack_public_path__ + "img/studiopro_login.06b2a0ac.png";